<template>
  <div>
    <div class="sortList">
      <van-tabs v-model="active" line-width="20">
        <van-tab title="推荐"></van-tab>
        <van-tab title="商城专区"></van-tab>
        <van-tab title="充值缴费"></van-tab>
        <van-tab title="本地生活"></van-tab>
        <van-tab title="本地生活"></van-tab>
        <van-tab title="本地生活"></van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 0,
      sortList: [
        { title: '电商购物', img: require('@/assets/img/coupon0.png') },
        { title: '汽服出行', img: require('@/assets/img/coupon1.png') },
        { title: '餐饮美食', img: require('@/assets/img/coupon2.png') },
        { title: '文娱健身', img: require('@/assets/img/coupon3.png') },
        { title: '便民服务', img: require('@/assets/img/coupon4.png') }
      ]
    }
  },
  created() {},
  computed: {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.sortList {
  //margin-top: 0.25rem;
  display: flex;
  justify-content: space-between;
  .sort {
    width: 0.55rem;
    height: 0.52rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    img {
      width: 0.3rem;
      height: 0.3rem;
      border-radius: 0.12rem;
    }
    .title {
      font-size: 0.13rem;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      color: #333333;
      line-height: 0.165rem;
    }
  }
}
</style>
